import { LessonInfo } from "./lesson-info";
import s from "../video-conf.module.scss";

export const WaitingState = ({
  appointment,
  isTeacher,
  onOpenSoundTest,
  onOpenCameraTest,
}) => (
  <div className={s.stateCard}>
    <LessonInfo
      appointment={appointment}
      isTeacher={isTeacher}
      onOpenSoundTest={onOpenSoundTest}
      onOpenCameraTest={onOpenCameraTest}
			disabled={true}
    />
  </div>
);
